export default __webpack_public_path__ + "static/media/announcement-bg.c7753d06.png";